var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isSisIcon)?_c(require(`@/components/icons/sis-icons/${_vm.svgName}.vue`).default,{tag:"component",class:_vm.iconClasses,attrs:{"size":this.size}}):_c(require(`@/components/icons/sis-icons/placeholder-outline.vue`).default,{tag:"component",attrs:{"size":this.size}})
}
var staticRenderFns = []

export { render, staticRenderFns }